function onClickOutside(container, callback) {
  function handleClick(event) {
    if (!container.contains(event.target)) {
      callback(event);
    }
  }

  document.addEventListener('click', handleClick);

  // Повертаємо функцію для видалення слухача, якщо потрібно
  return () => {
    document.removeEventListener('click', handleClick);
  };
}

export { onClickOutside }